<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->

<ngx-spinner type="ball-clip-rotate-multiple" bdColor="rgb(0,0,0,0)" color = "#00ff00"></ngx-spinner>
<gm-showcase>
  <div id="mainBody" class="showcase-body" ngForm #mainBody="ngForm">
    <br/>
    <table id="tableDriverInfo" #tableDriverInfo class="bordered-table" style="width: 100%;">
      <tr>
        <th colspan="99" style="background-color: #C7C7C7; font-weight: bold;">
          <table style="width:100%">
            <tr>
              <!--<td style="width:1px;">-->
                <!--<button class="btn btn-xs btn-secondary btn-group" (click)="ResetDriverInfo(urlDriverID)" title="Undo"><i class="fa fa-undo"></i></button>-->
              <!--</td>-->
              <td style="text-align: center">Person Information</td>
            </tr>
          </table>
        </th>
      </tr>
      <tr>
        <td><label for="person_firstname">First Name</label></td>
        <td>
          <input name="person_firstname" id="person_firstname" type="text" class="modelo-text-input"  [(ngModel)]="person.firstName" #person_firstname="ngModel" required>
          <small *ngIf="person_firstname.errors && person_firstname.errors.required" class="validationError">Required</small>
        </td>
        <td><label for="person_middlename">Middle Name</label></td>
        <td width="120px">
          <input name="person_middlename" id="person_middlename" type="text" class="modelo-text-input"  [(ngModel)]="person.middleName" #person_middlename="ngModel">
        </td>
        <td><label for="person_lastname">Last Name</label></td>
        <td>
          <input name="person_lastname" id="person_lastname" type="text" class="modelo-text-input"  [(ngModel)]="person.lastName" #person_lastname="ngModel" required>
          <small *ngIf="person_lastname.errors && person_lastname.errors.required" class="validationError">Required</small>
        </td>
      </tr>
      <tr>
        <td><label for="person_email">Email</label></td>
        <td colspan="2">
          <input  name="person_email" id="person_email" type="text" class="modelo-text-input"  [(ngModel)]="person.email" #person_email="ngModel" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$">
          <small *ngIf="person_email.errors && person_email.errors.pattern" class="validationError">Invalid Email Address</small>
        </td>
        <td><label for="person_phone">Phone #</label></td>
        <td colspan="2">
            <input  name="person_phone" id="person_phone" type="text" class="modelo-text-input"  [(ngModel)]="person.phoneNumber" #person_phone="ngModel" pattern="\d{3}[\-]\d{3}[\-]\d{4}">
            <small  *ngIf="person_phone.errors && person_phone.errors.pattern" class="validationError">Invalid Phone Format (123-456-7890)</small>
        </td>
      </tr>
      <tr>
        <td colspan="99" align="center">
          <button id="SaveChange" #SaveChange class="btn btn-primary btn-group" [disabled]="!mainBody.valid" (click)="SavePerson()"><i class="fa fa-save"></i>&nbsp;Save</button>&nbsp;
          <button id="ResetChange" #ResetChange  class="btn btn-primary btn-group" (click)="ResetFields()"><i class="fa fa-refresh"></i>&nbsp;Reset</button>
        </td>
      </tr>
    </table>
  </div>
</gm-showcase>
